module.exports = __webpack_public_path__ + "img/next.edd53408.png";